import { render } from "./BaliseAlarmTypeConfigs.vue?vue&type=template&id=a2797a8c&scoped=true"
import script from "./BaliseAlarmTypeConfigs.vue?vue&type=script&lang=js"
export * from "./BaliseAlarmTypeConfigs.vue?vue&type=script&lang=js"

import "./BaliseAlarmTypeConfigs.vue?vue&type=style&index=0&id=a2797a8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2797a8c"]])

export default __exports__